import { makeEnvironmentProviders, type EnvironmentProviders } from '@angular/core';
import {
  LIB_CONFIG,
  provideSecureStorage,
  type LibConfig,
} from '@copec-gid/gid-arquitectura.seguridad-autorizacion-modulo';

import type { SecurityConfig } from './security-config';

export function toLibConfig(config: SecurityConfig): LibConfig {
  return {
    apiUrl: config.apiUrl,
    publicKey: config.publicKey,
    applicationId: config.applicationId,
    levelid: config.levelId,
    usesSessionTokenApi: true,
    useHttpOnlyCookies: false,
    secureStorageBackend: 'indexedDB',
  };
}

export function provideSecurity(config: SecurityConfig): EnvironmentProviders {
  return makeEnvironmentProviders([{ provide: LIB_CONFIG, useValue: toLibConfig(config) }, provideSecureStorage()]);
}
